import { useEffect, useState } from 'react';

import { Modal, Button } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import toast from 'react-hot-toast';
import Flatpickr from "react-flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

import {
  servGetPendenciaFormularioComHistorico,
  servPutPendenciaItemFormulario
} from '../../servicos/servicosEmRotasPrivadas/pendencia_relatorio_acompanhamento';
import {
  servGetAllStatusTransitorios
} from '../../servicos/servicosEmRotasPrivadas/status';

import { formataDate, formataDatetime } from '../../util/datas'
import smartToast from '../../util/smart_toast';

function RespPendItemModal({ show, handleClose, pendenciaId, fetchItensAoFechar }) {

  console.log('#### Iniciando RespPendItemModal ####');

  const limiteCaracteresObs = 3000;

  const [data, setData] = useState(null)
  const [statusSelecionado, setStatusSelecionado] = useState(null)
  const [statusPendencia, setStatusPendencia] = useState(null)
  const [date, setDate] = useState('') // Usado pro input date funcionar corretamente
  const [countCaracteresObs, setCountCaracteresObs] = useState(0)
  const [exibeResumo, setExibeResumo] = useState(false)

  useEffect(() => {
    if (pendenciaId) getPendenciaFormularioComHistorico()
    setStatusSelecionado(null)
    setDate('')
    setCountCaracteresObs(0)
  }, [pendenciaId]);

  useEffect(() => {
    getAllStatusTransitorios()
  }, []);

  const getAllStatusTransitorios = async () => {
    try {
      const statusDaApi = await servGetAllStatusTransitorios()
      const ordemArbitraria = [3, 4, 2]; // ordem puramente arbitraria, como ja estava assim achei melhor não mudar pro usuário
      const ordenacaoFinal = ordemArbitraria.map(cod => statusDaApi.find(item => item.codigo === cod));
      setStatusPendencia(ordenacaoFinal)
    } catch (erro) {
      console.error(erro);
      toast.error(erro.message)
    }
  }

  const getPendenciaFormularioComHistorico = async () => {
    try {
      const pendenciaDaApi = await smartToast(
        servGetPendenciaFormularioComHistorico(pendenciaId),
        {
          loadingMessage: 'Buscando informações da pendência...',
          apenasLoading: true
        },
      );
      setData({
        pendencia: pendenciaDaApi.data.pendencia,
        resumoFragilidades: pendenciaDaApi.data.resumo_fragilidades,
        historico: pendenciaDaApi.data.historico
      });
    } catch (erro) {
      console.error(erro);
      toast.error(erro.message)
    }
  }

  const handlerEditaPendencia = (campo, valor) => {

    setData(prev => ({
      ...prev,
      pendencia: {
        ...prev.pendencia,
        [campo]: valor
      }
    }));
  };

  const handlerContaCaracteres = (e) => {
    setCountCaracteresObs(e.length)
  };

  const putPendencia = async (e) => {

    e.preventDefault();

    if (!statusSelecionado) {
      toast.error("Preciso que o item 'Pendência resolvida?' seja respondido.")
      return
    }

    const reqPutPendencia = {
      "id": data.pendencia.id,
      "observacao": data.pendencia.observacao,
      "status_id": statusSelecionado.statusId,
      "data": date
    }

    try {
      await smartToast(
        servPutPendenciaItemFormulario(reqPutPendencia),
        {
          loadingMessage: 'Enviando atualização...',
          apenasLoading: false
        },
      );

      fetchItensAoFechar()
      handleClose();

    } catch (error) {
      console.error(error.message);
      toast.error(error.message)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
      <form onSubmit={putPendencia}>
        <Modal.Header closeButton>
          <Modal.Title>Responder Pendência</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <div className='d-flex flex-column gap-3'>
              <p className='m-0'>Pendência resolvida?</p>
              <div className='d-flex gap-2'>
                {statusPendencia && statusPendencia.map((status) => (
                  <div key={status.id} className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      // id="flexRadioDefault1"
                      id={status.id}
                      value={status.id}
                      onChange={() => setStatusSelecionado({ resolvido: status.resolvido, statusId: status.id })} />
                    <label className="form-check-label" htmlFor={status.id}>{status.resolvido}</label>
                  </div>
                ))}
              </div>
              {statusSelecionado && (
                <div className='d-flex flex-column gap-3 p-1'>
                  {statusSelecionado.resolvido === 'Sim' ? (
                    <div className='form-group'>
                      <label htmlFor='dataResolucao'>Data de resolução</label>
                      <div className='col-12 col-md-3'>
                        <Flatpickr
                          name='dataResolucao'
                          value={date}
                          onChange={([selectedDate]) => setDate(selectedDate)}
                          options={{
                            dateFormat: "d/m/Y",
                            locale: Portuguese
                          }}
                          className="form-control"
                        />
                      </div>
                    </div>
                  ) : statusSelecionado.resolvido === 'Não' ? (
                    <>
                      {/* Não retorna campo de data */}
                    </>
                  ) : (
                    <div className='form-group'>
                      <label htmlFor='dataPrevisaoResolucao'>Data de previsão para resolução</label>
                      <div className='col-12 col-md-3'>
                        <Flatpickr
                          id='dataPrevisaoResolucao'
                          value={date}
                          onChange={([selectedDate]) => setDate(selectedDate)}
                          options={{
                            dateFormat: "d/m/Y",
                            locale: Portuguese
                          }}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  )}

                </div>
              )}

              {data &&

                <div className='d-flex flex-column gap-2'>
                  <div className="input-group">
                    <span className="input-group-text">Observação</span>
                    <textarea
                      className="form-control"
                      aria-label="With textarea"
                      placeholder={" *** Última Observação da pendência = " + data.pendencia.observacao || ""}
                      onBlur={(e) => handlerEditaPendencia("observacao", e.target.value)}
                      onChange={(e) => handlerContaCaracteres(e.target.value)}
                      required
                    />
                  </div>
                  <div className='d-flex gap-1'>
                    {countCaracteresObs > limiteCaracteresObs ? <p className='m-0 text-danger'>Caracteres: {countCaracteresObs}</p> : <p className='m-0'>Caracteres: {countCaracteresObs}</p>}
                    <p className='m-0'>-- Limite: {limiteCaracteresObs}</p>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="exibeResumo"
                      name="exibeResumo"
                      checked={exibeResumo}
                      onChange={(e) => setExibeResumo(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="exibeResumo">
                      Exibir Resumo Fragilidades
                    </label>
                  </div>
                  {exibeResumo &&
                    (
                      data.resumoFragilidades
                        ?
                        <div className=''>
                          <p className='m-0'><strong>Resumo das Fragilidades do Relatório que gerou essa pendência:</strong> {data.resumoFragilidades}</p>
                        </div>
                        :
                        <div>
                          <p className='m-0'>Não há Resumo das Fragilidades no documento que gerou essa pendência</p>
                        </div>
                    )
                  }
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Data Previsão Resolução</th>
                        <th>Data Alteração</th>
                        <th>Editor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.historico && data.historico.map((historico) => (
                        <tr key={historico.hist_id}>
                          <th scope="row">{historico.status}</th>
                          <td>{formataDate(historico.data_previsao_resolucao, 'dd/MM/yyyy')}</td>
                          <td>{formataDatetime(historico.data_alteracao)}</td>
                          <td>{historico.aud_nome}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button type='submit' variant="primary">SALVAR</Button>
            <Button variant="secondary" onClick={handleClose}>CANCELAR</Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal >
  );
}

export default RespPendItemModal;
